import { robotoRegular, scarpaGray500 } from '@habitech/shared';
import styled, { keyframes } from 'styled-components';

const moveUp = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px); // Ajusta la distancia que se moverá hacia arriba
  }
  100% {
    transform: translateY(0);
  }
`;

export const NotFoundMessage = styled.div`
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    margin: 48px 0;
    color: ${scarpaGray500};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    font-family: ${robotoRegular};
    animation: ${moveUp} 5s ease-in-out infinite;
`;
